import { Routes } from '@angular/router';

import { ActivateGuard } from './auth/activate/activate.guard';
import { ResetGuard } from './auth/reset/reset.guard';

export const APP_ROUTES: Routes = [
	{
		path: 'sign-in',
		loadComponent: () =>
			import('./layouts/sign-in-layout/sign-in-layout.component').then((m) => m.SignInLayoutComponent),
		data: { animationState: 'SignInLayoutComponent' },
	},
	{
		path: 'activate',
		loadComponent: () => import('./auth/activate/activate.component').then((m) => m.ActivateComponent),
		canActivate: [ActivateGuard],
	},
	{
		path: 'reset',
		loadComponent: () => import('./auth/reset/reset.component').then((m) => m.ResetComponent),
		canActivate: [ResetGuard],
	},
	{
		path: '',
		loadChildren: () => import('./page.routes').then((m) => m.PAGES_ROUTES),
	},
	{ path: '**', redirectTo: '' },
];
